export default [
  'Program',
  'Project',
  'dbGaP Study ID',
  'Files Registered',
  'Files Uploading',
  'Files Uploaded',
  'Files Validating',
  'Files Validated',
  'Files Submitted',
  'Files Released',
  'Files Error',
];
